import React from 'react';

export function About() {
  return (
    <div className="space-y-8">
      <div className="card bg-base-100 shadow-xl">
        <div className="card-body">
          <h2 className="card-title text-3xl">About Us</h2>
          <p className="text-lg">
            GS PC Parts and Builds: Your custom PC building experts. We offer made-to-order computer systems and parts,
            with expert consultation available through online chat. From concept to completion, we build your perfect PC
            without you leaving home.
          </p>
          <p className="text-xl font-bold text-primary mt-4">
            Custom PCs, built under your roof, just a chat away!
          </p>
        </div>
      </div>

      <div className="card bg-base-100 shadow-xl">
        <div className="card-body">
          <h3 className="card-title text-2xl">Our Mission</h3>
          <p className="text-lg">
            At GS PC Parts and Builds, our mission is to empower tech enthusiasts and professionals with custom-built PCs 
            that perfectly match their needs and aspirations. We combine expert knowledge, quality components, and 
            personalized service to deliver exceptional computing solutions, all from the comfort of your home.
          </p>
        </div>
      </div>

      <div className="card bg-base-100 shadow-xl">
        <div className="card-body">
          <h3 className="card-title text-2xl">Our Vision</h3>
          <p className="text-lg">
            We envision a world where every computer user has access to a perfectly tailored PC, built with expertise and care. 
            GS PC Parts and Builds strives to be the go-to platform for custom PC solutions, fostering a community where 
            technology dreams become reality through innovation, education, and unparalleled customer support.
          </p>
        </div>
      </div>
    </div>
  );
}